import { ExecutionStep } from "./ExecutionStepFormShared";
import { ExecutionJob } from "./caseExecutionJobDetailsTypes";
import dayjs from "dayjs";
import { ExecutionStepStatus } from "../../../types/ExecutionStatus";

type CaseReference = {
  id?: number;
  "@id"?: string;
};

export const formatDateTime = (value: string | null) => {
  if (!value) {
    return "-";
  }

  return dayjs(value).format("DD.MM.YYYY HH:mm");
};

export const shouldRenderExecutionAgentChip = (agentType: ExecutionJob["agentType"] | null | undefined) =>
  agentType === "LIA" || agentType === "LEXA";

export const isExecutionStepReorderableStatus = (status: ExecutionStepStatus) =>
  ["pending", "skipped"].includes(status);

export const reorderExecutionStepsLocally = (
  steps: ExecutionStep[],
  startIndex: number,
  endIndex: number
): ExecutionStep[] => {
  const reorderedSteps = [...steps];
  const [movedStep] = reorderedSteps.splice(startIndex, 1);
  reorderedSteps.splice(endIndex, 0, movedStep);

  return reorderedSteps.map((step, index) => ({
    ...step,
    position: index + 1,
  }));
};

export const hasExecutionStepError = (error: unknown) => {
  if (error === null || error === undefined) {
    return false;
  }

  if (Array.isArray(error)) {
    return error.length > 0;
  }

  if (typeof error === "string") {
    return error.trim().length > 0;
  }

  if (typeof error === "object") {
    return Object.keys(error).length > 0;
  }

  return true;
};

export const formatExecutionStepError = (error: unknown) => {
  if (!hasExecutionStepError(error)) {
    return "";
  }

  return typeof error === "string" ? error : JSON.stringify(error, null, 2);
};

export const extractNumericIdFromIri = (iri: string | undefined): number | null => {
  if (!iri) {
    return null;
  }

  const match = iri.match(/\/(\d+)$/);
  return match ? parseInt(match[1], 10) : null;
};

export const isExecutionJobDifferentCase = (
  executionJob: ExecutionJob,
  currentCase: CaseReference | undefined
): boolean => {
  const currentCaseId = currentCase?.id;
  const currentCaseIri = currentCase?.["@id"];
  const executionJobCaseIri = typeof executionJob.case === "string" ? executionJob.case : executionJob.case?.["@id"];
  const executionJobCaseId =
    typeof executionJob.case === "string"
      ? extractNumericIdFromIri(executionJob.case)
      : executionJob.case?.id || extractNumericIdFromIri(executionJob.case?.["@id"]);

  return (
    (executionJobCaseId !== null && !!currentCaseId && executionJobCaseId !== currentCaseId) ||
    (!executionJobCaseId && !!executionJobCaseIri && !!currentCaseIri && executionJobCaseIri !== currentCaseIri)
  );
};
